const routes = [
  // Landing Page
  {
    url: '/landing-page',
    file (resolve) { require(['./components/LandingPage'], resolve) }
  },
  // Dashboard
  {
    url: '/dashboard',
    file (resolve) { require(['./components/user-dashboard/Index.vue'], resolve) }
  },
  // Responsive Management
  {
    url: '/SOURCING-WF/Responsive-Management/Review-nomination',
    file (resolve) { require(['./components/responsivemanagment/GisWorkflow'], resolve) }
  },
  {
    url: '/SOURCING-WF/Responsive-Management/VENDOR-REPORT',
    file (resolve) { require(['./components/vendoraccessreport/VendorReport'], resolve) }
  },
  {
    url: '/SOURCING-WF/Responsive-Management/SUPERS-REPORT',
    file (resolve) { require(['./components/vendoraccessreport/SupersReport'], resolve) }
  },
  {
    url: '/SOURCING-WF/Responsive-Management/EXPORT-DATA',
    file (resolve) { require(['./components/exportdata/exportMain'], resolve) }
  },
  {
    url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/EXPORT-MULTI-DATA',
    file (resolve) { require(['./components/rpt-multiple-brand-report/exportMain'], resolve) }
  },
  {
    url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/EXPORT-MULTI-DATA-VIEW',
    file (resolve) { require(['./components/rpt-multiple-brand-report/PoListView'], resolve) }
  },
  // Booking Management
  {
    url: '/SOURCING-WF/Booking-Management/Review-booking',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/Booking-Management/Vd',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/BOOKING-Management/generatereport',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/Booking-Management/faq-gis',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/Booking-Management/faq-vendor',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/Booking-Management/faq-mst',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/Booking-Management/mst-task-assign',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/Booking-Management/mst-task-update',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/Booking-Management/BTM',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  // Change Management
  {
    url: '/SOURCING-WF/Change-Management/Initiate-receipt-changes',
    file (resolve) { require(['./components/changemanagement/CreateRequest'], resolve) }
  },
  {
    url: '/SOURCING-WF/Change-Management/Initiate-chase-changes',
    file (resolve) { require(['./components/changemanagement/NewChase'], resolve) }
  },
  {
    url: '/SOURCING-WF/Change-Management/Initiate-po-changes',
    file (resolve) { require(['./components/changemanagement/CreateRequestForPO'], resolve) }
  },
  {
    url: '/SOURCING-WF/Change-Management/Initiate-vendor-changes',
    file (resolve) { require(['./components/changemanagement/CreateRequestForLDL'], resolve) }
  },
  {
    url: '/SOURCING-WF/Change-Management/Review-receipt-changes',
    file (resolve) { require(['./components/changemanagement/SearchEdit'], resolve) }
  },
  {
    url: '/SOURCING-WF/Change-Management/Review-vendor-changes',
    file (resolve) { require(['./components/changemanagement/SearchEditForLDL'], resolve) }
  },
  {
    url: '/SOURCING-WF/Change-Management/Setup-notification',
    file (resolve) { require(['./components/changemanagement/EmailUserNotificationSettings'], resolve) }
  },
  {
    url: '/SOURCING-WF/Change-Management/FAQ-changemgmt',
    file (resolve) { require(['./components/changemanagement/FAQ-changemgmt'], resolve) }
  },
  {
    url: '/SOURCING-WF/Change-Management/General-Settings',
    file (resolve) { require(['./components/changemanagement/EmailNotificationSettings'], resolve) }
  },
  // Production Management
  {
    url: '/SOURCING-WF/Production-Management/Template-Config',
    file (resolve) { require(['./components/productionmanagement/TemplateManagement'], resolve) }
  },
  {
    url: '/SOURCING-WF/Production-Management/Milestone-Config',
    file (resolve) { require(['./components/productionmanagement/MilestoneManagement'], resolve) }
  },
  {
    url: '/SOURCING-WF/Production-Management/Production-Tracking',
    file (resolve) { require(['./components/productionmanagement/WipSearch'], resolve) }
  },
  {
    url: '/SOURCING-WF/Production-Management/Production-Reporting',
    file (resolve) { require(['./components/productionmanagement/Reporting'], resolve) }
  },
  // MST Vendor Connect
  {
    url: '/SOURCING-WF/SERVICE-REQUEST/CREATE',
    file (resolve) { require(['./components/sourcing_workflow/service_request/Create'], resolve) }
  },
  {
    url: '/SOURCING-WF/SERVICE-REQUEST/edit/:id',
    file (resolve) { require(['./components/sourcing_workflow/service_request/Edit'], resolve) }
  },
  {
    url: '/SOURCING-WF/SERVICE-REQUEST/MST-INTERFACE',
    file (resolve) { require(['./components/sourcing_workflow/service_request/Search'], resolve) }
  },
  // Admin
  {
    url: '/SOURCING-WF/ADMIN/ADMIN',
    file (resolve) { require(['./components/smee-administration/administration'], resolve) }
  },
  {
    url: '/SOURCING-WF/ADMIN/BATCH-TRIGGER',
    file (resolve) { require(['./components/batchtriggermanagement/batchTriggerList'], resolve) }
  },
  {
    url: '/SOURCING-WF/MY-SETTINGS/USER-SUBSCRIPTION',
    file (resolve) { require(['./components/my-settings/user-subscription'], resolve) }
  },
  {
    url: '/SOURCING-WF/MY-SETTINGS/PUSH-NOTIFICATION',
    file (resolve) { require(['./components/my-settings/push-notification'], resolve) }
  },
  // Sample Management.
  ...require('./components/samplemanagement/routes.js'),
  // Commitment Management
  ...require('./components/commitmentmanagement/routes.js'),
  // Capacity Management
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-CREATE',
    file (resolve) { require(['./components/capacitymanagement/cptCreate'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-ACKNOWLEDGE',
    file (resolve) { require(['./components/capacitymanagement/cptAcknowledge'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-ACKNOWLEDGE-VIEW',
    file (resolve) { require(['./components/capacitymanagement/cptAcknowledgeView'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-INPUT',
    file (resolve) { require(['./components/capacitymanagement/cptInput'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-INPUT-VIEW',
    file (resolve) { require(['./components/capacitymanagement/cptInputView'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-LIST',
    file (resolve) { require(['./components/capacitymanagement/cptList'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-LIST-VIEW',
    file (resolve) { require(['./components/capacitymanagement/cptListView'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-REPLACE',
    file (resolve) { require(['./components/capacitymanagement/replacePage'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-ACKNOWLEDGE-OVERALL-VIEW',
    file (resolve) { require(['./components/capacitymanagement/cptAcknowledgeOverAllView'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-LIST-OVERALL-VIEW',
    file (resolve) { require(['./components/capacitymanagement/cptListOverAllView'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-INPUT-OVERALL-VIEW',
    file (resolve) { require(['./components/capacitymanagement/cptInputOverAllView'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-REPLACE-OVERALL',
    file (resolve) { require(['./components/capacitymanagement/replaceOverallPage'], resolve) }
  },
  // VPS Extension
  {
    url: '/MASTER-DATA/VPS-EXTENSION/MILL-VENDOR-MASTER',
    file (resolve) { require(['./components/vps-extension/mill-vendor-master/VendorMaster'], resolve) }
  },
  {
    url: '/vps-extension/mill-vendor-master/view-profile/:id',
    file (resolve) { require(['./components/vps-extension/mill-vendor-master/view-profile/ViewProfile'], resolve) }
  },
  {
    url: '/vps-extension/mill-vendor-master/attribution/:id',
    file (resolve) { require(['./components/vps-extension/mill-vendor-master/attribution/Attribution'], resolve) }
  },
  {
    url: '/vps-extension/mill-vendor-master/relationship/:id',
    file (resolve) { require(['./components/vps-extension/mill-vendor-master/relationship/Relationship'], resolve) }
  },
  {
    url: '/MASTER-DATA/VPS-EXTENSION/MILL-FACILITY-PROFILE',
    file (resolve) { require(['./components/vps-extension/mill-facility-profile/List'], resolve) }
  },
  {
    url: '/vps-extension/mill-facility-profile/view-profile/:id',
    file (resolve) { require(['./components/vps-extension/mill-facility-profile/Detail'], resolve) }
  },
  {
    url: '/MASTER-DATA/VPS-EXTENSION/MILL-FACILITY-MASTER',
    file (resolve) { require(['./components/vps-extension/mill-facility-master/VendorMaster'], resolve) }
  },
  {
    url: '/vps-extension/mill-facility-master/attribution/:id',
    file (resolve) { require(['./components/vps-extension/mill-facility-master/attribution/Attribution'], resolve) }
  },
  {
    url: '/vps-extension/mill-facility-master/relationship/:id',
    file (resolve) { require(['./components/vps-extension/mill-facility-master/relationship/Relationship'], resolve) }
  },
  {
    url: '/MASTER-DATA/VPS-EXTENSION/MANUFACTURING-VENDOR-MASTER',
    file (resolve) { require(['./components/vps-extension/manufacturing-vendor-master/VendorMaster'], resolve) }
  },
  {
    url: '/vps-extension/manufacturing-vendor-master/vendor-master-view',
    file (resolve) { require(['./components/vps-extension/manufacturing-vendor-master/VendorMasterView'], resolve) }
  },
  // Test Result Management
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/TEST-REPORT',
    file (resolve) { require(['./components/LandingTrmPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/DETAIL',
    file (resolve) { require(['./components/LandingTrmPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/VIEW',
    file (resolve) { require(['./components/LandingTrmPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/INTERNAL-TEST-REPORT',
    file (resolve) { require(['./components/LandingTrmPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/INTERNALDETAIL',
    file (resolve) { require(['./components/LandingTrmPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/INTERNALVIEW',
    file (resolve) { require(['./components/LandingTrmPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/report-review',
    file (resolve) { require(['./components/testresultmanagement/ReportView'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/ReportViewBYId',
    file (resolve) { require(['./components/testresultmanagement/ReportViewBYId'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/REPORTVIEWDETAIL',
    file (resolve) { require(['./components/testresultmanagement/ReportViewDetail'], resolve) }
  },
  // QAS
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/SEARCH-SHIPMENT',
    file (resolve) { require(['./components/qas/searchShipment'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/SEARCH-AUDIT',
    file (resolve) { require(['./components/qas/searchAudit'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/CREATE-AUDIT',
    file (resolve) { require(['./components/qas/createAudit'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/EDIT-AUDIT',
    file (resolve) { require(['./components/qas/createAudit'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/COPY-AUDIT',
    file (resolve) { require(['./components/qas/createAudit'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/CREATE-CORRELATIONAUDIT',
    file (resolve) { require(['./components/qas/createAudit'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/PASS-RATE',
    file (resolve) { require(['./components/qas/passRate'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/PLM',
    file (resolve) { require(['./components/qas/PLM'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/PLM-CHART',
    file (resolve) { require(['./components/qas/plmChart'], resolve) }
  }
].map(route => ({
  path: route.url,
  component: route.file
}))

export default routes



// WEBPACK FOOTER //
// ./src/routes.js